<template>
  <div class="login-page">
    <h1 style="color: #333">登录</h1>
    <a-tabs v-model:activeKey="activeKey" :animated="false">
      <a-tab-pane key="1" tab="微信登录">
        <div class="ewm">
          <vue-qr
            :text="imageUrl"
            :size="230"
            style="border: 1px solid #e8e8e8"
          ></vue-qr>
          <div class="cover" v-if="scanStatus === 1">
            <div class="tip">二维码已过期</div>
            <a-button type="primary" @click="getWechatSid"
              ><span style="font-size: 15px">刷新</span></a-button
            >
          </div>
          <div class="cover cover2" v-if="scanStatus === 2">
            <div class="text">扫描成功!</div>
            <div class="text">请勿刷新页面，在手机上确认登录!</div>
          </div>
        </div>
        <div class="wxPng">
          <img v-lazy="'@/assets/img/wxPng.png'" alt="" />
          <!-- <img src="@/assets/img/wxPnggif.gif" alt=""> -->
        </div>
        <div class="textTip">
          打开微信，使用扫一扫功能，扫描二维码即可登录，二维码60秒后过期。
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="验证码登录" force-render>
        <div style="margin: 40px auto">
          <span style="font-weight: bold; font-size: 16px; color: #333"
            >登录账号</span
          ><br />
          <a-input
            v-model:value.trim()="phone"
            placeholder="请输入您的手机号"
            style="
              background: #f3f3f4;
              width: 440px;
              height: 44px;
              margin-top: 15px;
              margin-bottom: 25px;
            "
          />

          <div class="input-wrap drag-verify" v-show="!hasSend">
            <span
              style="
                float: left;
                font-weight: bold;
                font-size: 16px;
                color: #333;
              "
              >验证码</span
            ><br />
            <div class="bar" style="margin-top: 15px">
              <div class="bar-con">请按住滑块拖到最右边</div>
              <div class="draged" ref="draged"></div>
              <div class="drag-btn" ref="dragBtn">&gt;&gt;</div>
              <div class="cover"></div>
            </div>
            <div class="clear"></div>
          </div>

          <a-input-group
            compact
            style="
              margin-top: 20px;
              color: #333;
              font-size: 16px;
              font-weight: bold;
            "
            v-show="hasSend"
          >
            <div style="float: left">输入验证码</div>
            <br />
            <a-input
              v-model:value="verifyCode"
              style="
                width: calc(100% - 102px);
                text-align: left;
                margin-top: 15px;
                background: #f3f3f4;
                height: 44px;
              "
            />
            <a-button
              type="button"
              class="btn"
              @click="getCode"
              style="width: 102px; margin-top: 15px; height: 44px"
              :disabled="btnText !== '重新发送'"
              >{{ btnText }}</a-button
            >
          </a-input-group>
          <a-button
            @click="login"
            class="loginBtn"
            style="
              margin-top: 38px;
              width: 225px;
              background-color: #393939;
              color: white;
              height: 44px;
              border-radius: 4px;
              border:none
            "
            >立即登录</a-button
          >
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import {
  defineComponent,
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
} from "vue";
import config from "../../until/configs";
import { useRoute, useRouter, onBeforeRouteLeave } from "vue-router";
import VueQr from "vue-qr/src/packages/vue-qr.vue";
import Http from "../../until/http";
import axios from "axios";
import {
  setCookie,
  getCookie,
  messageTips,
  isPhone,
  setLocalItem,
  getLocalItem,
  delCookie,
} from "../../until/tools";
var timer;
export default defineComponent({
  components: { VueQr },
  setup() {
    const route = useRoute();
    const router = useRouter();
    let activeKey = ref("1");
    let draged = ref(null);
    let dragBtn = ref(null);

    const state = reactive({
      phone: "",
      verifyCode: "",
      imageUrl: "",
      scanStatus: 0,
      sid: getCookie("z_sid"),
      openSid: "",
      hasSend: false,
      btnText: "重新发送",
    });
    const getCode = () => {
      if (state.phone === "") {
        messageTips("请输入手机号", 2);
        return;
      }
      if (!isPhone(state.phone)) {
        messageTips("请输入正确的手机号", 2);
        return;
      }
      Object.assign(state, {
        btnText: 59 + "秒刷新",
      });
      Http.getSign({ account: state.phone }).then((res) => {
        Http.getCode({ account: state.phone, sign: res.sign }).then((res) => {
          if (res.verifyCode) {
            //存一下用来做登录校验
            // setCookie("verifyCode", res.verifyCode, { time: 1 });
            Object.assign(state, {
              verifyCode: res.verifyCode,
            });
          }
        });
      });
      let seconds = 59;
      timer = setInterval(() => {
        Object.assign(state, {
          btnText: seconds + "秒刷新",
        });
        if (seconds < 0) {
          clearInterval(timer);
          Object.assign(state, {
            btnText: "重新发送",
          });
          return false;
        }
        seconds -= 1;
      }, 1000);
    };

    const locationTarget = () => {
      location.reload();
    };

    const login = (e) => {
      e.preventDefault();
      if (state.phone === "") {
        messageTips("请输入手机号", 2);
        return false;
      }
      if (!isPhone(state.phone)) {
        messageTips("请输入正确的手机号", 2);
        return false;
      }
      if (state.verifyCode === "") {
        messageTips("请输入验证码", 2);
        return false;
      }
      clearInterval(setWechatTimer);
      //手机是否存在，存在直登，否则填基本信息
      Http.mobileIsExist({
        mobile: state.phone,
      }).then((res) => {
        if (res && res.success) {
          //若已经ip登录 多传个groupid
          if (getLocalItem("isIPLogin")) {
            Http.login({
              groupId: getLocalItem("groupId"),
              account: state.phone,
              verifyCode: state.verifyCode,
              loginType: 0,
            }).then((res) => {
              if (res && res.success) {
                setLocalItem("userInfo", res.userInfo);
                setCookie("z_sid", res.sid, 1);
                setCookie("userId", res.userInfo.userId, { time: 1 });
                setLocalItem("isUserLogin", {
                  isUserLogin: res.isUserLogin,
                });
              } else {
                messageTips(res.message, 2);
              }
              if (res.sid) {
                //是否需要去完善机构信息
                Http.getUserInfo({
                  sid: res.sid,
                }).then((res) => {
                  if (res.isGroup) {
                    if (route.query.sign == 66) {
                      window.location.href =
                        "http://test.sozdata.com/site.html#/index";
                    } else if (route.query.sign == 88) {
                      window.location.href =
                        "http://test.sozdata.com/tqexam.html#/user/signUp";
                    } else {
                      locationTarget();
                    }
                  } else {
                    // router.push("/login/guidance");
                    if (route.query.sign == 66) {
                      window.location.href =
                        "http://test.sozdata.com/site.html#/index";
                    } else if (route.query.sign == 88) {
                      window.location.href =
                        "http://test.sozdata.com/tqexam.html#/user/signUp";
                    } else {
                      locationTarget();
                    }
                  }
                });
              }
            });
          } else {
            setLocalItem("account", state.phone);
            Http.login({
              account: getLocalItem("account"),
              verifyCode: state.verifyCode,
              loginType: 0,
            }).then((res) => {
              if (res && res.success) {
                setLocalItem("userInfo", res.userInfo);
                setCookie("z_sid", res.sid, 1);
                setCookie("userId", res.userInfo.userId, { time: 1 });
                setLocalItem("isUserLogin", {
                  isUserLogin: res.isUserLogin,
                });
              } else {
                messageTips(res.message, 2);
              }
              if (res.sid) {
                //是否需要去完善机构信息
                Http.getUserInfo({
                  sid: res.sid,
                }).then((res) => {
                  if (res.isGroup) {
                    if (route.query.sign == 66) {
                      window.location.href =
                        "http://test.sozdata.com/site.html#/index";
                      // window.location.href = "http://192.168.1.145:8081/site.html#/index";
                    } else if (route.query.sign == 88) {
                      window.location.href =
                        "http://test.sozdata.com/tqexam.html#/user/signUp";
                    } else {
                      locationTarget();
                    }
                  } else {
                    if (route.query.sign == 66) {
                      window.location.href =
                        "http://test.sozdata.com/site.html#/index";
                      //  window.location.href = "http://192.168.1.145:8081/site.html#/index";
                    } else if (route.query.sign == 88) {
                      window.location.href =
                        "http://test.sozdata.com/tqexam.html#/user/signUp";
                    } else {
                      locationTarget();
                    }
                  }
                });
              }
            });
          }
        } else {
          // let verifyCode = getCookie("verifyCode");
          // if (verifyCode !== state.verifyCode) {
          //   messageTips("验证码错误，请重新输入！", 1);
          //   return false;
          // }
          Http.affirmCode({
            account: state.phone,
            verifyCode: state.verifyCode,
          }).then((res) => {
            if (res.success) {
              if (route.query.sign == 66) {
                router.push(
                  "/login/bind?account=" +
                    state.phone +
                    "&&verifyCode=" +
                    state.verifyCode +
                    "?sign=66"
                );
              } else if (route.query.sign == 88) {
                router.push(
                  "/login/bind?account=" +
                    state.phone +
                    "&&verifyCode=" +
                    state.verifyCode +
                    "?sign=88"
                );
              } else {
                router.push(
                  "/login/bind?account=" +
                    state.phone +
                    "&&verifyCode=" +
                    state.verifyCode
                );
              }
            } else {
               messageTips(res.message, 2);
            }
          });
        }
      });
    };
    let setWechatTimer;
    let getWechatSid = () => {
      axios.get(config.GeneralPath + "main/login/sid").then((res) => {
        state.imageUrl = config.weChatUrl + "#/wechatlogin?sid=" + res.data;
        state.scanStatus = 0;
        state.openSid = res.data;
        if (setWechatTimer) {
          clearInterval(setWechatTimer);
        }
        setWechatTimer = setInterval(() => {
          getEachWeChat(res.data);
        }, 1000);
      });
    };
    const getEachWeChat = (sid) => {
      axios
        .post(config.GeneralPath + "main/" + "login/check/wx/" + sid + "/1")
        .then((res) => {
          //是否登录成功
          if (res.data.status) {
            setCookie("z_sid", res.data.sid, { time: 1 });
            if (res.data.userInfo) {
              setCookie("userId", res.data.userInfo.userId, { time: 1 });
              setLocalItem("userInfo", res.data.userInfo);
              setLocalItem("isUserLogin", {
                isUserLogin: res.isUserLogin,
              });
            }
            clearInterval(setWechatTimer);
            if (route.query.sign == 66) {
              window.location.href =
                "http://test.sozdata.com/site.html#/index";
            } else if (route.query.sign == 88) {
              window.location.href =
                "http://test.sozdata.com/tqexam.html#/user/signUp";
            } else {
              locationTarget();
            }
          } else {
            // 二维码过期
            if (res.data.overdue) {
              clearInterval(setWechatTimer);
              state.scanStatus = 1;
            }
            // 扫描成功
            if (res.data.phoneStatus) {
              state.scanStatus = 2;
            }
            // 点击（微信页面的）取消关闭弹窗
            if (res.data.canCelStatus) {
              state.scanStatus = 0;
              // clearInterval(setWechatTimer);
              getWechatSid();
            }
            //是否绑定手机 true为没有
            if (res.data.openStatus && res.data.openId) {
              clearInterval(setWechatTimer);
              if (route.query.sign == 66) {
                router.push(
                  "/login/bind_phone?openSid" + "=" + state.openSid + "?sign=66"
                );
              } else if (route.query.sign == 88) {
                router.push(
                  "/login/bind_phone?openSid" + "=" + state.openSid + "?sign=88"
                );
              } else {
                router.push("/login/bind_phone?openSid" + "=" + state.openSid);
              }
            }
            return;
          }
        });
    };
    onMounted(() => {
      if (getCookie("z_sid")) {
        let locationTarget = getCookie("locationTarget");
        if (locationTarget) {
          delCookie("locationTarget");
          window.location.href = locationTarget;
        } else {
          router.push("/");
        }
      }
      getWechatSid();
      var dragBtnDom = dragBtn.value;
      var leftBorder = 880 - 362 + (window.innerWidth - 880) / 2;
      dragBtnDom.onmousedown = () => {
        dragBtnDom.style.transition = "";
        draged.value.style.transition = "";
        if (state.phone === "") {
          messageTips("请输入手机号", 2);
          return;
        }
        if (!isPhone(state.phone)) {
          messageTips("请输入正确的手机号", 2);
          return;
        }
        var newLeft;
        document.onmousemove = (e) => {
          newLeft = e.pageX - leftBorder;
          if (newLeft < 0) {
            newLeft = 0;
          }
          if (newLeft > 375) {
            newLeft = 375;
          }
          dragBtnDom.style.left = newLeft + "px";
          draged.value.style.width = newLeft + "px";
        };
        document.onmouseup = () => {
          document.onmousemove = null;
          document.onmouseup = null;
          if (newLeft) {
            if (newLeft < 375) {
              dragBtnDom.style.left = 0;
              dragBtnDom.style.transition = "all 400ms ease 0s";
              draged.value.style.width = 0;
              draged.value.transition = "all 400ms ease 0s";
            } else {
              //clearInterval(setTimer);
              Object.assign(state, {
                hasSend: true,
                btnText: "59秒刷新",
              });
              getCode();
            }
          }
        };
        return false;
      };

      window.onresize = () => {
        leftBorder = 880 - 362 + (window.innerWidth - 880) / 2;
      };
    });
    onUnmounted(() => {
      clearInterval(setWechatTimer);
    });
    onBeforeRouteLeave((to, from, next) => {
      if (to.path == "/index") {
        clearInterval(setWechatTimer);
        next();
      } else {
        next();
      }
    });

    return {
      activeKey,
      getEachWeChat,
      ...toRefs(state),
      // showWxLogin,
      getCode,
      login,
      getWechatSid,
      draged,
      dragBtn,
    };
  },
});
</script>
<style lang="scss">
.login-page {
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  user-select: none;
  h1 {
    font-weight: bold;
  }
}
</style>
<style lang="scss" scoped>
  .loginBtn:hover,.loginBtn:focus{
     border-color: #fff;
  }
/deep/.ant-tabs-ink-bar {
  background-color: #387df8 !important;
}
/deep/ .ant-tabs-nav-wrap {
  text-align: left;
}
/deep/.ant-tabs-nav .ant-tabs-tab {
  // margin: 0 40px !important;
  font-size: 18px !important;
}
/deep/.ant-tabs-bar {
  margin: 0;
}
/deep/ input:hover {
  border-color: #387df8;
}
/deep/ button:hover {
  border-color: #387df8;
  color: #387df8;
}
/deep/.loginBtn:hover {
  border-color: #fff;
}
.ewm {
  position: relative;
  width: 230px;
  // margin: 18px auto;
  margin-top: 50px;
  .cover {
    position: absolute;
    top: 0;
    left: 0;
    width: 232px;
    height: 100%;
    margin: 0 auto;
    z-index: 1;
    background: rgba(0, 0, 0, 0.5);
    .tip {
      padding-top: 72px;
      padding-bottom: 24px;
      padding-left: 62px;
      color: #fff;
      font-size: 16px;
    }
    /deep/ button {
      margin-left: 77px;
      background-color: #387bf6 !important;
      border-color: #387bf6 !important;
      color: #fff;
    }
  }
  .cover2 {
    color: #fff;
    font-size: 15px;
    .text:first-child {
      padding-top: 60px;
      padding-bottom: 30px;
      text-align: center;
    }
  }
}
.wxPng {
  position: absolute;
  top: 107px;
  right: 0;
  width: 200px;
  img {
    width: 100%;
  }
}
.textTip {
  margin: 0 auto;
  margin-top: 30px;
  font-size: 12px;
  color: #666;
}
.input-wrap {
  position: relative;
  margin-top: 20px;
  .label-name {
    text-align: left;
  }
  .bar {
    height: 44px;
    background: #f3f3f4;
    border-radius: 4px;
    position: relative;
    width: 440px;
  }
  .bar .bar-con {
    line-height: 44px;
    text-align: center;
    font-size: 15px;
    color: #aaa;
  }
  .bar .drag-btn {
    width: 64px;
    height: 44px;
    font-size: 21px;
    position: absolute;
    top: 0;
    left: 0;
    color: #bbb;
    background: #fff;
    text-align: center;
    line-height: 42px;
    cursor: pointer;
    border: 1px solid #d8d8d8;
  }
  .bar .drag-btn .ico-pass {
    width: 14px;
    height: 14px;
    background-position: -30px -57px;
    position: relative;
    top: 2px;
  }
  .bar .draged {
    height: 44px;
    width: 0;
    background: #387bf6;
    position: absolute;
    top: 0;
    left: 0;
    text-align: center;
    line-height: 44px;
    color: #fff;
    font-size: 15px;
  }
  .bar .cover {
    width: 100%;
    height: 44px;
    position: absolute;
    z-index: 99;
    left: 0;
    top: 0;
    display: none;
  }
}
#app .ant-btn-primary:disabled {
  font-size: 14px;
  color: #333;
  background: #fff;
  border-color: #e8e8e8;
}
</style>